/*
    A service used to trigger GTM pushes
*/
webClient.factory('trackingService', ['$window', 'gtmModel', 'gtmProduct',
    function ($window, gtmModel, gtmProduct) {
        return {

            isActivated: function () {
                return (typeof $window.dataLayer !== 'undefined' && $window.dataLayer != null);
            },

            initDataLayer: function (name) {
                $scope.gtm = new gtmModel(name);
            },

            /*
                Reload data using JSON stored in window.sessionStorage
                The action name / value is used as key 
            */
            loadSessionData: function (action, value) {
                return $scope.gtm.loadSessionData(action, value);

            },

            /*
                Use to send page views. Distinct gtm object in order not to mess with ecommerce tunnel
            */
            pushPageData: function (page, title, language, fireEvent, args) {

                if ($window.dataLayer) {

                    var gtm = {
                        event: 'Pageview',
                        page: page,
                        title: title,
                        language: language
                    };

                    if (title.toLowerCase() === 'error') {
                        var message = $('.c-warn-msg .c-npad').text().replace(/\s+/g, ' ');
                        gtm.errorCode = 591;
                        gtm.errorMessage = message;
                    }

                    if (title.toLowerCase() === 'booking warning') {
                        var message = $('.c-accord-payment-ko div').text().replace(/\s+/g, ' ');;
                        gtm.errorCode = 593;
                        gtm.errorMessage = message;
                    }

                    var datalayer = JSON.stringify(gtm);

                    console.log(datalayer);

                    if (typeof $window.dataLayer[0].version === 'undefined') {
                        //send page event
                        $window.dataLayer.push(gtm);
                        //remove last
                        $window.dataLayer.splice($window.dataLayer.length - 1, 1);
                        //insert first
                        $window.dataLayer.splice(0, 0, gtm);  
                    }
                    else {
                        //send page event
                        $window.dataLayer.push(gtm);
                        //remove last
                        $window.dataLayer.splice($window.dataLayer.length - 1, 1);
                        //insert first
                        $window.dataLayer.splice(1, 0, gtm);
                    }
                }
            },

            addProduct: function (product) {
                $scope.gtm.addProduct(product);
            },

            removeProduct: function (id) {
                $scope.gtm.removeProduct(id);
            },

            setOption: function (value) {
                $scope.gtm.setAction('option', value);
            },

            parseScope: function (value) {
                $scope.gtm.addProduct(gtmProduct.parseScope(value));
            },

            /*
                Serializes the GTM model and pushes the datalayer
            */
            pushDataLayer: function (action, value) {

                // depends on <Item Type="Inline" Id="googleTagManager"> in xml file: if empty, no datalayer is declared and nothing will be pushed
                if ($window.dataLayer) {
                    var overrideAction = action != null && value != null;

                    var rootProperty = "";
                    for (var key in $scope.gtm.ecommerce) { rootProperty = key; }

                    //remove properties prefixed by _
                    var products = $scope.gtm.ecommerce[rootProperty].products;
                    var data = {};

                    var bookingId = null;

                    /*
                        In Thomas Cook, everything is send at root level. We just loop over each product, 
                        read each property, and add it to a brand new object that will be serialized
                    */
                    for (var i = 0; i < products.length; i++) {
                        for(var key in products[i]) {
                            if (key !== 'bookingId') {
                                data[key] = products[i][key];
                            }
                            else {
                                bookingId = products[i][key];
                            }
                        }
                    }

                    data.realParametersOfVirtualpages = window.location.search.toString();
                    data.realUrlPathOfVirtualpages = window.location.pathname.toString();

                    //on corfirmation page, we have to add ecommerce
                    if (action == null && value == null) {
                        data.ecommerce = {
                            purchase: {
                                actionField: {
                                    id: bookingId,
                                    affiliation: 'MisterFly',
                                    revenue: data.priceTotalFlight,
                                    tax: data.priceTax,
                                    shipping: 0,
                                    coupon: data.coupon
                                },
                                products: [{
                                    id: data.productNameVol,
                                    name: data.productNameVol,
                                    price: data.priceTotalFlight / data.paxTotalVol,
                                    brand: data.company,
                                    category: "Vol",
                                    variant: data.categoryVol,
                                    quantity: data.paxTotalVol,
                                    coupon: data.coupon
                                }]
                            }
                        };

                        //copy pageview properties
                        data.page = '/Flightsearch/BookingOK';
                        data.title = 'Booking OK';
                        data.language = $window.lng;
                    }

                    if (value === 4) {
                        //copy pageview properties
                        data.page = '/Flightsearch/Payment/CB';
                        data.title = 'Payment CB';
                        data.language = $window.lng;
                    }

                    var datalayer = JSON.stringify(data).replace(/("_[^"]+":"[^"]+",?)/, "");

                    console.log(datalayer);

                    if (overrideAction) {
                        $window.sessionStorage.setItem('gtmModel-' + action + '-' + value, JSON.stringify($scope.gtm));
                    }
                    //send ecommerce
                    $window.dataLayer.push(JSON.parse(datalayer));
                    //remove last
                    $window.dataLayer.splice($window.dataLayer.length - 1, 1);
                    //insert first
                    $window.dataLayer.splice(0, 0, JSON.parse(datalayer));
                }
            }
        };
    }]);

